module.exports = __webpack_public_path__ + "static/keeping-his-head-in-the-game-index-fca385b7ebc2252545d338130c156129.jpg";